import {NgModule} from "@angular/core";
import {RouterModule, Routes} from "@angular/router";
import {PageNotFoundComponent} from "fello-common";
import {SearchWidgetComponent} from "./components/search-widget/search-widget.component";
import {AgencyWidgetSettingResponseResolver} from "./resolvers/agency-widget-setting-response.resolver";

const routes: Routes = [
  {
    path: "offer/:widgetId",
    redirectTo: "/lp/:widgetId"
  },
  {
    path: "search/:widgetId",
    component: SearchWidgetComponent,
    title: "Sell My Home",
    resolve: {
      settings: AgencyWidgetSettingResponseResolver
    }
  },
  {
    path: "**",
    component: PageNotFoundComponent
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class OfferWidgetsRoutingModule {}
